import { TableCell, Tooltip, Typography } from "@mui/material";
import { useMemo } from "react";

const PatientCountCell = ({ data }) => {
  const { count = 0, patients = [] } = data ?? {};
  const title = useMemo(() => {
    if (patients.length === 0) return "";
    return (
      <div>
        {patients.map((p) => (
          <Typography key={p.mulDartaaNumber} variant="body2">
            {p.patientName} ({p.mulDartaaNumber})
          </Typography>
        ))}
      </div>
    );
  }, [patients]);

  return (
    <Tooltip title={title} placement="top" arrow>
      <TableCell>{count}</TableCell>
    </Tooltip>
  );
};

export default PatientCountCell;
